import { Link } from 'react-router-dom';
import { setactiveItem } from 'store/cards';
import CommonItemFlag from './common-item/CommonItemFlag';
import CommonItemInfo from './common-item/CommonItemInfo';
import { useDispatch } from 'react-redux';
import { useSoundPath } from 'hooks/useSoundPath';
import useActiveItem from 'hooks/useActiveItem';

const MyHubCardList = ({ title, list, link }) => {

  const {isActiveItem, activeItem} = useActiveItem();
  const dispatch = useDispatch();
  const playSound = useSoundPath();

  const itemClickHandler = (item) => {
    dispatch(setactiveItem(item));
    playSound('main');
  }


  return (
    <section className="cards-list">
      <header className="cards-list__header">
        <div className="cards-list__header-info">
          <h2 className="cards-list__title">
            {title}
            <span>{list.length}</span>
          </h2>
        </div>
        <Link to={link} className="cards-list__header-link" onClick={() => playSound('main')}>See All</Link>
      </header>
      <ul className={`cards-list__block cards-list__block--min cards-list__block--in-row`}>
          {
            list.map((item) => (
              <li className={`cards-list__block-item ${activeItem === item ? 'active' : ''}`} key={item.id} onClick={() => itemClickHandler(item)} >
                <CommonItemInfo name={item.name} image={item.image} props={item.properties} />
                <p className="cards-list__block-item-text">
                  {
                    item.name === '' ? item.id : item.name
                  }
                  <CommonItemFlag isListed={item.is_listed} isMine={item.owned_by_self} />
                </p>
              </li>
            ))
          }
        </ul>
    </section>
  )
}

export default MyHubCardList;
